import { getColumns } from "components/Common/DataTablev2/processor";
import isObjectEmpty from "./isObjectEmpty";

const exportToCsv = (
  data: Record<string, any>[],
  columnsToHide?: string[],
  customColumns?: Record<string, any>
) => {
  const headers = getColumns(data).filter(
    //eslint-disable-next-line  @typescript-eslint/strict-boolean-expressions
    (item) => !columnsToHide?.includes(item)
  );

  const customColumnsExist = customColumns && !isObjectEmpty(customColumns);
  let filteredHeaders = headers;
  //eslint-disable-next-line  @typescript-eslint/strict-boolean-expressions
  if (customColumnsExist) {
    filteredHeaders = filteredHeaders
      .map((header) => {
        //eslint-disable-next-line  @typescript-eslint/strict-boolean-expressions
        if (customColumns[header]) {
          if (
            customColumns[header]?.export === undefined ||
            customColumns[header]?.export === true
          )
            return header;
          return "";
        }
        return header;
      })
      .filter((x) => x);
  }
  const formatForExport = (text: string) =>
    text.replaceAll(",", "").replace(/"/g, '""');

  const tableData = data.map((item) => {
    return filteredHeaders
      .map((header) => {
        //eslint-disable-next-line  @typescript-eslint/strict-boolean-expressions
        if (customColumnsExist && customColumns[header]) {
          const needsFormatting =
            customColumnsExist &&
            Object.prototype.hasOwnProperty.call(
              customColumns[header],
              "valueFormatter"
            );
          if (needsFormatting) {
            try {
              // Get value, handling null/undefined
              const value = item[header] !== undefined ? item[header] : null;
              // Pass the raw value to the valueFormatter
              const formattedValue = customColumns[header].valueFormatter(value);
              // After formatting, ensure it's returned as a string for CSV
              return typeof formattedValue === 'string' 
                ? formatForExport(formattedValue) 
                : formatForExport(String(formattedValue || ''));
            } catch (error) {
              console.error(`Error formatting ${header}:`, error);
              return formatForExport(`${item[header] ?? " "}`);
            }
          }
        }
        return formatForExport(`${item[header] ?? " "}`);
      })
      .filter((x) => x);
  });
  
  // Use custom header names from customColumns if available
  let csvHeaders = filteredHeaders;
  if (customColumnsExist) {
    csvHeaders = filteredHeaders.map((header) => {
      // Use the exact header name from the headerName property if available
      if (customColumns[header] && customColumns[header].headerName) {
        // Return the exact header name as it appears in the UI
        return customColumns[header].headerName;
      }
      // If no headerName specified, fall back to uppercase column name
      return header.toUpperCase(); 
    });
  } else {
    // If no custom columns, convert to uppercase for consistency
    csvHeaders = csvHeaders.map((header) => header.toUpperCase());
  }
  
  const csvData = [csvHeaders, ...tableData];
  const csvContent = csvData.map((e) => e.join(",")).join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  // Create a link element
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "investor_allocations.csv");

  // Programmatically trigger a click on the link to initiate the download
  link.click();
};
export default exportToCsv;
